if (!customElements.get('adev-featured-columns')) {
    customElements.define('adev-featured-columns', class adevFeaturedColumns extends HTMLElement {
        constructor() {
            super();

            this.carouselEl = this.querySelector('[data-adev-featured-columns="carousel"]');
        }
        
        
        initSlider(){
            const getCellAlign = () => window.innerWidth < 768 ? 'center' : 'left';

            this.slider = new Flickity(this.carouselEl, {
                cellAlign: getCellAlign(),
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true
            });

            this._onResize = () => {
                const align = getCellAlign();
                this.slider.options.cellAlign = align;
                this.slider.resize();
                this.slider.positionCells();
                this.slider.select(this.slider.selectedIndex, false, true);
            };

            window.addEventListener('resize', this._onResize);
        }

        destroySlider(){
            if (this.slider) {
                this.slider.destroy();
            }
            
            if (this._onResize) {
                window.removeEventListener('resize', this._onResize);
                this._onResize = null;
            }
        }

        connectedCallback() {
            this.initSlider();
            this.shopifyCustomizerInit();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

        shopifyCustomizerInit(){
            if (Shopify.designMode) {
                document.addEventListener('shopify:block:select', (e) => {
                    const block = e.detail;

                    const blockId = block.blockId;
                    const sectionId = block.sectionId;

                    const blockElement = this.querySelector(`[data-id="${blockId}"]`);
                    
                    if (blockElement) {
                        const index = blockElement.getAttribute('data-index');
                        this.slider.select(index);
                    }
                });

                document.addEventListener('shopify:block:deselect', (e) => {
                    const block = e.detail;

                    const blockId = block.id;
                    const sectionId = block.sectionId;
                });
            }
        }

    });
}